module.exports = __webpack_public_path__ + "static/media/img_06.9e21a4a9.png";